import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const X: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M609.49 187.51L404.5 391.3L596.47 583.26L575.26 604.47L383.25 412.46L189.11 605.48L168.09 584.46L362.26 391.47L166.53 195.74L187.74 174.53L383.52 370.31L565.43 189.54C571.61 183.35 579.83 179.95 588.57 179.95C596.24 179.95 603.63 182.63 609.49 187.51Z' />
  </IconBase>
));

X.displayName = 'X';

export default X;
